module.exports = __webpack_public_path__ + "static/media/CY.dc1f9dc0.png";